import {ReactNode} from 'react';
import {htmlContentRenderer} from '../components/content';

export const getContentWithHtml = (content: string): ReactNode =>
  htmlContentRenderer(content);

export const hasHtmlTags = (content: string): boolean => {
  const htmlTagRegex = /<[^>]*>/g;
  return htmlTagRegex.test(content);
};
